import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import {
  TEXT_FIELD,
  ATTACHMENT,
  CHECKBOX,
  DATE,
  EMAIL,
  NUMBER_FIELD,
  PHONE,
  RADIO,
  SCALE,
  SELECT_ENUM,
  SELECT_LOOKUP,
  HIDDEN,
} from '../../constants/InputTypes';

import CheckboxInput from './CheckboxInput';
import DateInput from './DateInput';
import EmailInput from './EmailInput';
import linkField from '../../utils/linkField';
import NumberInput from './NumberInput';
import PhoneInput from './PhoneInput';
import SelectInput from './SelectInput';
import selectOptions from '../../utils/selectOptions';
import TextInput from './TextInput';
import AddOptionInput from './AddOptionInput';

class RootField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lookup) {
      const {
        lookupValue, lookup: {
          entity, link, label, value, number, orderByValue,
        }, token,
      } = nextProps;
      selectOptions({
        entity, field: link, fieldValue: lookupValue, token, label, value, number, orderByValue,
      }).then(options => this.setState({ options }));
    }
    if (nextProps.link) {
      const {
        linkValue, link: { entity, value }, token, dispatch, formName, formData,
      } = nextProps;
      linkValue && linkField({
        token, entity, entityID: linkValue, value,
      }).then((linkedValue) => {
        linkedValue !== formData.values[value] && dispatch(change(formName, value, linkedValue));
      });
    }
  }

  render() {
    const {
      type, name, allowAddOption, label, lookup,
    } = this.props;
    // fix warning: https://reactjs.org/warnings/unknown-prop.html
    const {
      lookupValue, linkValue, formName, formData, valuesByKey, ...rest
    } = this.props;
    const { options } = this.state;
    const addOption = allowAddOption &&
      (valuesByKey[`Show.AddOption.${formName}.${lookup.entity}`] &&
      valuesByKey[`Show.AddOption.${formName}.${lookup.entity}`].Value === 'true') ? (
        <AddOptionInput
          entity={lookup.entity}
          entityField={lookup.value}
          entityForm={formName}
          entityLink={lookup.link}
          entityLookup={lookup.lookupValue}
          inputField={lookup.label}
          label={label}
        />
      ) : null;
    let field = null;
    switch (type) {
      case NUMBER_FIELD:
        field = (<Field {...rest} name={name} component={NumberInput} />);
        break;
      case DATE:
        field = (<Field {...rest} name={name} component={DateInput} />);
        break;
      case TEXT_FIELD:
        field = (<Field {...rest} name={name} component={TextInput} />);
        break;
      case EMAIL:
        field = (<Field {...rest} name={name} component={EmailInput} />);
        break;
      case PHONE:
        field = (<Field {...rest} name={name} component={PhoneInput} />);
        break;
      case SCALE:
      case RADIO:
      case SELECT_ENUM:
        field = (<Field {...rest} name={name} component={SelectInput} />);
        break;
      case CHECKBOX:
        field = (<Field {...rest} name={name} component={CheckboxInput} />);
        break;
      case SELECT_LOOKUP:
        field = (
          <Field {...rest} name={name} component={SelectInput} options={options || []} />
        );
        break;
      case ATTACHMENT:
        field = (<Field {...rest} name={name} component="input" type="file" />);
        break;
      case HIDDEN:
        field = (<div />);
        break;
      default:
        return <span>{`THIS TYPE OF INPUT IS NOT SUPPORTED: ${type}`}</span>;
    }
    return (
      <div>
        {field}
        {addOption}
      </div>
    );
  }
}

RootField.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  lookupValue: PropTypes.any,
  lookup: PropTypes.object,
  linkValue: PropTypes.any,
  link: PropTypes.object,
  token: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  formName: PropTypes.string,
  formData: PropTypes.object,
  allowAddOption: PropTypes.bool,
  valuesByKey: PropTypes.object,
  label: PropTypes.node,
};

export default connect(state => ({ valuesByKey: state.WebValuesReducer.valuesByKey }))(RootField);



// WEBPACK FOOTER //
// ./src/components/form/RootField.js